import { transition } from '@helpers/animate';
import brand from '@helpers/brand';
import { fluid } from '@helpers/fluid';
import fonts from '@helpers/fonts';
import { ButtonReset } from '@helpers/global';
import { baseGrid } from '@helpers/grid';
import { imageCoverContainer, imageWrapperPreserveRatio } from '@helpers/image';
import { Device, from } from '@helpers/media';
import { h4 } from '@helpers/typography';
import Image from '@stories/Components/Misc/Image/Image';
import SectionWrapper from '@stories/Components/Misc/SectionWrapper/SectionWrapper';
import SectionWrapperStyles from '@stories/Components/Misc/SectionWrapper/SectionWrapper.styles';
import styled from 'styled-components';
const Container = styled(SectionWrapper) `
  --top: ${fluid(0, 50)};
  --sectionSpacing: ${fluid(40, 80)};

  overflow: hidden;

  &::before,
  &::after {
    ${transition('transform', 0.66)}

    content: '';
    display: block;
    position: absolute;
    width: 50%;
    height: calc(50% - (var(--top) * 0.5));
    transition-delay: 300ms;

    @media ${from(Device.Tablet)} {
      transition-duration: 800ms;
    }

    @media ${from(Device.TabletLarge)} {
      --top: ${fluid(30, 50)};

      transition-duration: 1s;
    }

    @media ${from(Device.Desktop)} {
      transition-duration: 1.2s;
    }

    @media ${from(Device.ActualDesktop)} {
      transition-duration: 1.33s;
    }
  }

  &::before {
    background-color: ${brand.primary.blueGrey};
    top: var(--top);
    left: 0;
    border-radius: 0 5000px 5000px 0;
  }

  &::after {
    background-color: ${brand.primary.orange};
    bottom: 0;
    right: 0;
    border-radius: 5000px 0 0 5000px;
  }

  &[data-animate='false'] {
    &::before {
      transform: translateX(calc((100% - var(--sitePadding)) * -1));
    }

    &::after {
      transform: translateX(calc(100% - var(--sitePadding)));
    }
  }

  ${SectionWrapperStyles.Inner} {
    ${baseGrid};

    position: relative;
    z-index: 1;
  }
`;
const ContentWrapper = styled.div `
  text-align: center;
  grid-column: span 24;
  color: ${brand.base.blue};
  position: relative;

  @media ${from(Device.TabletLarge)} {
    grid-column: 3 / span 20;
  }

  @media ${from(Device.DesktopSmall)} {
    grid-column: 5 / span 16;
  }

  @media ${from(Device.DesktopLarge)} {
    grid-column: 6 / span 14;
  }
`;
const Title = styled.h2 `
  ${h4};

  margin: 0 0 40px;
`;
const Content = styled.p `
  ${fonts.apparat.light};

  font-size: ${fluid(18, 20)};
  line-height: ${fluid(28, 30)};
  margin: 0 auto 40px;
  max-width: 68ch;
`;
const AspectRatio = styled.div `
  ${ButtonReset};
  ${imageWrapperPreserveRatio(1020, 573)}

  color: var(--fgColour);
  display: block;
  border-radius: 10px;

  &.focus-ring {
    outline: auto;
    outline-offset: 5px;
    outline-style: solid;
    outline-width: 2px;
  }
`;
const Img = styled(Image) `
  ${imageCoverContainer()}
`;
const PlayIcon = styled.span `
  color: #ff0000;
  display: block;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  padding: ${fluid(12, 18)};

  > svg {
    display: block;
    width: 68px;
    height: 48px;
  }
`;
const TextMediaStyles = {
    AspectRatio,
    Container,
    Content,
    ContentWrapper,
    Img,
    PlayIcon,
    Title,
};
export default TextMediaStyles;
